export default __webpack_public_path__ + "static/media/icn-small-success.83623670.svg";